/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAppointmentBookingResponse } from './GetAppointmentBookingResponse';
import {
    GetAppointmentBookingResponseFromJSON,
    GetAppointmentBookingResponseFromJSONTyped,
    GetAppointmentBookingResponseToJSON,
    GetAppointmentBookingResponseToJSONTyped,
} from './GetAppointmentBookingResponse';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface GetBulkAppointmentBookingsItem
 */
export interface GetBulkAppointmentBookingsItem {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof GetBulkAppointmentBookingsItem
     */
    appointmentId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {Array<GetAppointmentBookingResponse>}
     * @memberof GetBulkAppointmentBookingsItem
     */
    bookings: Array<GetAppointmentBookingResponse>;
}

/**
 * Check if a given object implements the GetBulkAppointmentBookingsItem interface.
 */
export function instanceOfGetBulkAppointmentBookingsItem(value: object): value is GetBulkAppointmentBookingsItem {
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('bookings' in value) || value['bookings'] === undefined) return false;
    return true;
}

export function GetBulkAppointmentBookingsItemFromJSON(json: any): GetBulkAppointmentBookingsItem {
    return GetBulkAppointmentBookingsItemFromJSONTyped(json, false);
}

export function GetBulkAppointmentBookingsItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBulkAppointmentBookingsItem {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['appointmentId']),
        'bookings': ((json['bookings'] as Array<any>).map(GetAppointmentBookingResponseFromJSON)),
    };
}

export function GetBulkAppointmentBookingsItemToJSON(json: any): GetBulkAppointmentBookingsItem {
    return GetBulkAppointmentBookingsItemToJSONTyped(json, false);
}

export function GetBulkAppointmentBookingsItemToJSONTyped(value?: GetBulkAppointmentBookingsItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['appointmentId']),
        'bookings': ((value['bookings'] as Array<any>).map(GetAppointmentBookingResponseToJSON)),
    };
}

